"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTitleForProcedureRoute = exports.getProcedureRoute = void 0;
function getProcedureRoute(uid, title) {
    return `/d/${uid}/${encodeURIComponent(prepareTitleForProcedureRoute(title))}`;
}
exports.getProcedureRoute = getProcedureRoute;
function prepareTitleForProcedureRoute(rawTitle) {
    let title = rawTitle.slice(0, 100);
    if (title.length === 100) {
        const lastSpaceIndex = title.lastIndexOf(" ");
        title = title.slice(0, lastSpaceIndex);
    }
    title = title
        .toLocaleLowerCase()
        // https://tools.ietf.org/html/rfc3986#section-2.2
        .replace(/[ !#$&'()*+,/:;=?@\[\]]/g, "-")
        // Can't use this as long as we support IE.
        // .replace(/[^\p{Alpha}\d]/gu, "-")
        .replace(/--+/g, "-");
    return title;
}
exports.prepareTitleForProcedureRoute = prepareTitleForProcedureRoute;
//# sourceMappingURL=routes.js.map